(() => {
	const debugMode = 1,
		testId = "GLX-004",
		logInfo = testId + " -->",
		variation = 2,
		prefixClass = `ab-${testId}`;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			// Wait for an element(s) to be fully loaded in the DOM
			const waitForElement = (cssSelector, callback, multi = false, maxCalls = 300) => {
				try {
					let elementsCached;

					const interval = setInterval(() => {
						try {
							if (multi) {
								elementsCached = document.querySelectorAll(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached.length) {
									clearInterval(interval);
									callback(elementsCached);
								}
							} else {
								elementsCached = document.querySelector(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached) {
									clearInterval(interval);
									callback(elementsCached);
								}
							}

							// After trying to find the element for 6 seconds, it stops
							if (typeof maxCalls === "number" && --maxCalls < 0) {
								clearInterval(interval);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					}, 20);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const html = `
				<div class="${testId}-checkout-progress">
					<div class="${testId}-progress-bar">
						<div class="progress-fill"></div>
					</div>
					<div class="${testId}-checkout-steps">
						<span class="step active">Cart</span>
						<span class="step">Shipping</span>
						<span class="step">Payment</span>
					</div>
				</div>
			`;

			// Add cart progress
			const addCartProgress = () => {
				try {
					const cartDrawer = document.querySelector("#cart-drawer");
					const freeShippingBar = document.querySelector(".free-shipping-bar");

					if (cartDrawer) {
						if (!cartDrawer.querySelector(`.${testId}-checkout-progress`)) {
							freeShippingBar.insertAdjacentHTML("beforebegin", html);
						}
					}
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement("body", (bodyElement) => {
				try {
					new MutationObserver(addCartProgress).observe(bodyElement, {
						childList: true,
						subtree: true
					});

					addCartProgress();
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();